import React from 'react';
import { Link } from "react-router-dom";
import ApexLinePlant from "./ApexLinePlant"
import ClientManualScrollPlant from "./ClientManualScrollPlant"

function ClientPlantCode(){
    

    return (
       
        <>
          <div class="row">
            <div class="col-sm-6">
          <div className="card" style={{width: "18rem;"}}>
  <div className="card-body">





  
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="iconCard"> 
                        
                        <span class="material-symbols-rounded">home_work</span>

                        </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">North Gate Office</h6> <span style={{color:"#e5603c"}}>2 </span><span>Bank | <strong>Plant ID:</strong> 24598</span>
                        </div>
                    </div>
                    <div class="badge" style={{display: "flex"}}> 
                    <div class="material-symbols-rounded plantLink" >Settings</div>
                    
                    <div class="material-symbols-rounded plantLink" >language</div> 
                    <span>Plant</span> </div>
                </div>
                <hr />

                <div style={{display: "flex"}}>
               

                
                <span className='plantIcon'>
                <span className='bankFont'><span class="material-symbols-rounded writing" >bolt</span> 
                
                North Gate</span>
                <hr  style={{border:"1px solid rgb(214, 236, 255)", marginBottom:"0px", marginTop:"10px"}}/>
                    <p style={{fontSize:"30px"}}><span class="material-symbols-rounded">battery_5_bar</span>
                    <strong>50v</strong>
                    </p>
                </span>
             




                
               
                <Link to="/dashboard" className='plantIcon2'>
                <span className='bankFont2'><span class="material-symbols-rounded" >dashboard</span> 
                
                </span>
                
                    <p style={{fontSize:"15px" }}>
                    <strong>Dashboard</strong>
                    </p>
                  </Link>

                  <Link to="/battery" className='plantIcon3'>
                <span className='bankFont2'><span class="material-symbols-rounded" >battery_5_bar</span> 
                
                </span>
                
                    <p style={{fontSize:"15px" }}>
                    <strong>Install Battery</strong>
                    </p>
                  </Link>

                 
               
                
    </div>
            <hr />

            <div class="mt-3">
                    <div class="mt-3">
                        
                       
                        

                        <div className='d-flex'>

                         <span class="text1" style={{marginTop:"-5px", marginRight:"10px"}}>North Gate <span class="text2">Bank</span></span> 

   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Min: </strong></span>

   <p className='Font-Blue currentCharging'>45V</p> 
    
    </div>

    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Max: </strong></span>

   <p className='Font-primary currentCharging'>53V</p> 
    
    </div>
  </div>


                    </div>
                </div>

    <ApexLinePlant />
    
   
   
  </div>
</div></div>




<div class="col-sm-3">
    <div className="card" style={{width: "18rem;"}}>
        <div className="card-body">

        <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="iconCard"> 
                        
                        <span class="material-symbols-rounded">info</span>

                        </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Information</h6> 
                            
                           {/*  <span style={{color:"#e5603c"}}>1 </span><span>Active Ticket </span>*/}


                        </div>
                    </div>
                    <div class="badge" style={{display: "flex"}}> 
                    <div class="material-symbols-rounded plantLink" >Settings</div>
                    
                  
                    </div>
                </div>
                <hr />

                <p><strong>Manuals: </strong></p>

                <ClientManualScrollPlant />
                

        </div>

    


    </div>

    <div >
 <span className='BIcon3'><span class="material-symbols-rounded size" style={{paddingTop:"4px", marginleft:"5px"}}>add_box</span> <span style={{paddingTop:"5px"}}>Add Plant</span></span>
 </div>

 
</div>













<div class="col-sm-3">
    <div className="card" style={{width: "18rem;"}}>
        <div className="card-body">
            

        <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="iconCard"> 
                        
                        <span class="material-symbols-rounded">support</span>

                        </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Support</h6> {/*<span style={{color:"#e5603c"}}>1 </span><span>Active Ticket </span>*/}
                        </div>
                    </div>
                    <div class="badge" style={{display: "flex"}}> 
                    <div class="material-symbols-rounded plantLink" >Settings</div>
                    
                  
                    </div>
                </div>
                <hr />
                <p><strong>Ticket: </strong></p>
   
<div className='d-flex'>
    
   <div className='smallInfo' style={{display: "flex"}}>
    
   {/*  <span class="material-symbols-rounded writing">support_agent</span> */}<span style={{marginTop: "-3px", paddingLeft:"5px"}}>{/*<strong>Ticket</strong> */}

   <div>

   <a href="https://forms.monday.com/forms/8bab8b0e829844b0d2962e0e865f097c?r=use1" target="_blank" rel="noopener noreferrer">
 <span className='BIcon3' style={{marginTop:"0px", marginBottom:"20pxs"}}><span class="material-symbols-rounded size" style={{paddingTop:"6px", marginRight:"5px"}}>support_agent</span> <span style={{paddingTop:"9px"}}>Log A Ticket</span></span>
</a>

 </div>
    
   Please note that it could take up to 7 -10 days to resolve a ticket depending on the volume of support queries and the severity of tickets
     </span>

    
    </div>

   
  </div>
    <hr />
   
    <p><strong>Register Your Battery: </strong></p>
   
   <div className='d-flex'>
       
      <div className='smallInfo' style={{display: "flex", width:"100%"}}>
       
      {/*  <span class="material-symbols-rounded writing">support_agent</span> */}<span style={{marginTop: "-3px", paddingLeft:"5px", width:"100%"}}>{/*<strong>Ticket</strong> */}
   
      <a href="https://www.i-g3n.co.za/register-your-battery/" target="_blank" rel="noopener noreferrer">
   <div>
    <span className='BIcon3' style={{marginTop:"0px", marginBottom:"20pxs"}}><span class="material-symbols-rounded size" style={{paddingTop:"6px", marginRight:"5px"}}>battery_5_bar</span> <span style={{paddingTop:"9px"}}>Battery Registration</span></span>

    </div>
    </a>
     
        </span>
   
       
       </div>
   
      
     </div>



     <hr />
   
    <p><strong>FAQ: </strong></p>
   
   <div className='d-flex'>
       
      <div className='smallInfo' style={{display: "flex", width:"100%"}}>
       
      {/*  <span class="material-symbols-rounded writing">support_agent</span> */}<span style={{marginTop: "-3px", paddingLeft:"5px", width:"100%"}}>{/*<strong>Ticket</strong> */}
   
      <div>
    <span className='BIcon3' style={{marginTop:"0px", marginBottom:"20pxs"}}><span class="material-symbols-rounded size" style={{paddingTop:"6px", marginRight:"5px"}}>Help</span> <span style={{paddingTop:"9px"}}>Frequently Asked Questions</span></span>
    </div>
     
        </span>
   
       
       </div>
   
      
     </div>
   
   


        </div>
    </div>
</div>
          </div>
        </>
    )
}

export default ClientPlantCode;